var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 18.89 20.734"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.903 17.738a3 3 0 0 1 .044-.515l-8.016-4.57a3 3 0 0 1-1.935.709 3 3 0 0 1-3-3 3 3 0 0 1 3-3 3 3 0 0 1 1.935.709l8.016-4.57a3 3 0 0 1-.044-.515 3 3 0 0 1 2.992-3 3 3 0 0 1 3 3 3 3 0 0 1-3 3 2.98 2.98 0 0 1-2.088-.85l-7.9 4.506a3 3 0 0 1 .088.72 3 3 0 0 1-.088.72l7.9 4.506a2.98 2.98 0 0 1 2.087-.85 3 3 0 0 1 3 3 3 3 0 0 1-3 3 2.994 2.994 0 0 1-2.991-3",
    "data-name": "network"
  })));
};
export default SvgShare;